// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 500px) {
    .scl--jcbs-sub-app-bo-con-st{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-left);
    }

    .scl--jbs-car-ti-bo-dis-st p, .scl--jbs-car-ti-bo-dis-st span{
        font-size: 24px;
    }

    .scl--jctbds-btn-st .scl--web-component-round-button-text{
        font-size: 28px;
    }

    .scl--jbs-car-ti-bo-dis-st{
        min-height: 500px;
        padding: 25px 25px 50px 25px;
    }

    .scl--jbs-car-ti-bo-dis-st span{
        margin-top: auto;
    }

    .scl--jctbds-btn-st{
        width: 100%;
        height: 61px;
        margin-top: 25px;
        border-radius: 30px;
    }

    .scl--jbcs-num-bo-st{
        flex-direction: column;
    }

    .scl--jnbs-coun-se-bo-st{
        width: 100%;
    }

    .scl--jnbs-pho-num-bo-st{
        width: 100%;
    }

    .scl--fbucs-grp-at-up-st{
        flex-direction: column;
        align-items: start;
    }

    .scl--fgaus-ro-bt-st{
        width: 100%;
        height: 57px;
        border-radius: 30px;
    }

    .scl--fgaus-ro-bt-st span{
        font-size: 24px;
    }

    .scl--fgaus-sp-te-st{
        width: 100%;
        font-size: 18px;
    }

    .scl--fi-bo-up-co-st .scl--web-component-round-button{
        width: 100%;
        height: 57px;
        border-radius: 30px;
    }

    .scl--fi-bo-up-co-st .scl--web-component-round-button span{
        font-size: 24px;
    }

    .scl--jbics-val-bo-ch-st{
        position: relative;
        gap: 10px;
    }

    .scl--jvbcs-des-bo-st{
        text-indent: 35px;
    }

    .scl--jbics-val-bo-ch-st .scl--web-component-checkbox-container{
        position: absolute;
        z-index: 100;
    }

    .scl--jsabcs-bo-st{
        gap: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-detail/css/jobSubmittedSm.css"],"names":[],"mappings":"AAAA;IACI;QACI,+CAA+C;QAC/C,gDAAgD;IACpD;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;AACJ","sourcesContent":["@media (max-width: 500px) {\n    .scl--jcbs-sub-app-bo-con-st{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-left);\n    }\n\n    .scl--jbs-car-ti-bo-dis-st p, .scl--jbs-car-ti-bo-dis-st span{\n        font-size: 24px;\n    }\n\n    .scl--jctbds-btn-st .scl--web-component-round-button-text{\n        font-size: 28px;\n    }\n\n    .scl--jbs-car-ti-bo-dis-st{\n        min-height: 500px;\n        padding: 25px 25px 50px 25px;\n    }\n\n    .scl--jbs-car-ti-bo-dis-st span{\n        margin-top: auto;\n    }\n\n    .scl--jctbds-btn-st{\n        width: 100%;\n        height: 61px;\n        margin-top: 25px;\n        border-radius: 30px;\n    }\n\n    .scl--jbcs-num-bo-st{\n        flex-direction: column;\n    }\n\n    .scl--jnbs-coun-se-bo-st{\n        width: 100%;\n    }\n\n    .scl--jnbs-pho-num-bo-st{\n        width: 100%;\n    }\n\n    .scl--fbucs-grp-at-up-st{\n        flex-direction: column;\n        align-items: start;\n    }\n\n    .scl--fgaus-ro-bt-st{\n        width: 100%;\n        height: 57px;\n        border-radius: 30px;\n    }\n\n    .scl--fgaus-ro-bt-st span{\n        font-size: 24px;\n    }\n\n    .scl--fgaus-sp-te-st{\n        width: 100%;\n        font-size: 18px;\n    }\n\n    .scl--fi-bo-up-co-st .scl--web-component-round-button{\n        width: 100%;\n        height: 57px;\n        border-radius: 30px;\n    }\n\n    .scl--fi-bo-up-co-st .scl--web-component-round-button span{\n        font-size: 24px;\n    }\n\n    .scl--jbics-val-bo-ch-st{\n        position: relative;\n        gap: 10px;\n    }\n\n    .scl--jvbcs-des-bo-st{\n        text-indent: 35px;\n    }\n\n    .scl--jbics-val-bo-ch-st .scl--web-component-checkbox-container{\n        position: absolute;\n        z-index: 100;\n    }\n\n    .scl--jsabcs-bo-st{\n        gap: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
